import type { TFunction } from 'i18next';
import { z } from 'zod';
import { jsonSchemaType } from '@/shared/schema';

export const createObjectSchema = (
  t: TFunction<'compat'>,
  categoryMetadataSchema: z.ZodObject<z.ZodRawShape>,
  dynamicMetadataSchema: z.ZodObject<z.ZodRawShape>
) =>
  z.object({
    name: z.string().min(1, t('validation.required')),
    description: z.string().optional(),
    category: z.string().optional().nullable(),
    assignedCustomer: z.string().optional(),
    dynamicMetadataSchema: jsonSchemaType,
    categoryMetadataValues: categoryMetadataSchema,
    dynamicMetadataValues: dynamicMetadataSchema,
  });

// Default schema for cases where we don't need validation
const _fakeT = (() => 'Required') as unknown as TFunction<'compat'>;
export const objectFormSchema = createObjectSchema(
  _fakeT,
  z.object({}).catchall(z.unknown()),
  z.object({}).catchall(z.unknown())
);
